import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import PhysicalClientForm from './PhysicalClientForm'
import OrganizationClientForm from './OrganizationClientForm'
import { AddClientFormTrigger } from './AddClientFormTrigger'
import ClientFormModals from './ClientFormModals'

import reducer from './reducer'
import saga from './saga'
import * as constants from './constants'

export { PhysicalClientForm, OrganizationClientForm, AddClientFormTrigger, ClientFormModals, reducer, saga, constants }

export default Loadable(() => import('./AddClientForm'))
